// import React, { useEffect, useState } from 'react';
// import './BudgetLineTransactions.css';
// import privateApi from '../../apis/privateApi';
// import Spinner from '../../components/Spinner/Spinner';
// // import ConfirmDialog from '../../components/ConfirmDialog/ConfirmDialog';

// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { FiEye } from "react-icons/fi";

// const BudgetLineTransactions = () => {
//     const location = useLocation();
//     const navigate = useNavigate();

//     const budgetLine = location?.state?.budgetLine;

//     const [transactions, setTransactions] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState('');

//     const [filters, setFilters] = useState({
//         budgetLineId: budgetLine._id,
//         referenceNumber: '',
//         type: '',
//         status: [],
//         minAmount: '',
//         maxAmount: '',
//         startDate: '',
//         endDate: ''
//     });

//     const [pagination, setPagination] = useState({
//         page: 1,
//         limit: 10,
//         totalPages: 1,
//         totalRecords: 0
//     });

//     // // Delete states
//     // const [confirmOpen, setConfirmOpen] = useState(false);
//     // const [confirmToken, setConfirmToken] = useState("");
//     // const [deleteId, setDeleteId] = useState(null);

//     // const generateToken = () =>
//     //     Math.random().toString(36).substring(2, 8).toUpperCase();

//     const handleStatusChange = (value, checked) => {
//         setFilters(prev => {
//             let updatedStatuses = [...prev.status];
//             if (checked) {
//                 if (!updatedStatuses.includes(value)) updatedStatuses.push(value);
//             } else {
//                 updatedStatuses = updatedStatuses.filter(s => s !== value);
//             }
//             return { ...prev, status: updatedStatuses };
//         });
//     };

//     // Fetch Transactions
//     const fetchTransactions = async () => {
//         try {
//             setLoading(true);
//             setError('');

//             const params = new URLSearchParams();
//             params.append('page', pagination.page);
//             params.append('limit', pagination.limit);

//             Object.entries(filters).forEach(([key, value]) => {
//                 if (value != null && value !== '') {
//                     if (Array.isArray(value)) {
//                         // Append each item separately: status=posted&status=reversed
//                         value.forEach(v => params.append(key, v));
//                     } else {
//                         params.append(key, value);
//                     }
//                 }
//             });

//             const { data } = await privateApi.get(`/api/transactions?${params.toString()}`);

//             if (data.success) {
//                 setTransactions(data.data);
//                 setPagination(prev => ({
//                     ...prev,
//                     totalPages: data.pagination?.pages || 1,
//                     totalRecords: data.pagination?.total || data.data.length
//                 }));
//             } else {
//                 setTransactions([]);
//                 setError('No records found');
//             }
//         } catch (err) {
//             setTransactions([]);
//             setError(err.response?.data?.message || 'Failed to fetch transactions.');
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         const initialFetchTransactions = async () => {
//             try {
//                 setLoading(true);
//                 setError('');

//                 const params = new URLSearchParams();
//                 params.append('page', pagination.page);
//                 params.append('limit', pagination.limit);

//                 Object.entries(filters).forEach(([key, value]) => {
//                     if (value != null && value !== '') {
//                         if (Array.isArray(value)) {
//                             // Append each item separately: status=posted&status=reversed
//                             value.forEach(v => params.append(key, v));
//                         } else {
//                             params.append(key, value);
//                         }
//                     }
//                 });

//                 const { data } = await privateApi.get(`/api/transactions?${params.toString()}`);

//                 if (data.success) {
//                     setTransactions(data.data);
//                     setPagination(prev => ({
//                         ...prev,
//                         totalPages: data.pagination?.pages || 1,
//                         totalRecords: data.pagination?.total || data.data.length
//                     }));
//                 } else {
//                     setTransactions([]);
//                     setError('No records found');
//                 }
//             } catch (err) {
//                 setTransactions([]);
//                 setError(err.response?.data?.message || 'Failed to fetch transactions.');
//             } finally {
//                 setLoading(false);
//             }
//         };

//         initialFetchTransactions();
//     }, [filters, pagination.page, pagination.limit]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFilters(prev => ({ ...prev, [name]: value }));
//     };

//     const applyFilters = () => {
//         setPagination(prev => ({ ...prev, page: 1 }));
//         fetchTransactions();
//     };

//     const handleLimitChange = (e) => {
//         const limit = parseInt(e.target.value, 10);
//         setPagination(prev => ({ ...prev, limit, page: 1 }));
//     };

//     const nextPage = () => {
//         if (pagination.page < pagination.totalPages) {
//             setPagination(prev => ({ ...prev, page: prev.page + 1 }));
//         }
//     };

//     const prevPage = () => {
//         if (pagination.page > 1) {
//             setPagination(prev => ({ ...prev, page: prev.page - 1 }));
//         }
//     };

//     // -------------------
//     // Delete logic
//     // -------------------
//     // const handleDeleteClick = (id) => {
//     //     const token = generateToken();
//     //     setDeleteId(id);
//     //     setConfirmToken(token);
//     //     setConfirmOpen(true);
//     // };

//     // const handleConfirmDelete = async (input) => {
//     //     if (input !== confirmToken) {
//     //         alert("Incorrect confirmation code.");
//     //         setConfirmOpen(false);
//     //         return;
//     //     }
//     //     try {
//     //         await privateApi.delete(`/api/transactions/${deleteId}`);
//     //         fetchTransactions();
//     //     } catch (err) {
//     //         alert(err.response?.data?.message || "Delete failed.");
//     //     } finally {
//     //         setConfirmOpen(false);
//     //         setDeleteId(null);
//     //     }
//     // };

//     // const handleCancelDelete = () => {
//     //     setConfirmOpen(false);
//     //     setDeleteId(null);
//     // };

//     return (
//         <div className="budget-line-transactions-container">
//             <header className="budget-line-transactions-header">
//                 <h2>Budget Line Transactions</h2>
//                 <button className="budget-line-transactions-back-btn" onClick={() => navigate(-1)}>Back</button>
//             </header>

//             {/* Filters */}
//             <div className="budget-line-transactions-filters">
//                 <input
//                     name="referenceNumber"
//                     placeholder="Reference Number"
//                     value={filters.referenceNumber}
//                     onChange={handleChange}
//                 />

//                 {/* Type Select */}
//                 <select name="type" value={filters.type} onChange={handleChange}>
//                     <option value="">All Types</option>
//                     <option value="debit">Debit</option>
//                     <option value="credit">Credit</option>
//                 </select>

//                 {/* Status Checkboxes */}
//                 <div className='budget-line-transactions-status'>
//                     <div>Status:</div>
//                     <div className="budget-line-transactions-status-checkboxes">
//                         <label>
//                             <input
//                                 type="checkbox"
//                                 value="posted"
//                                 checked={filters.status.includes("posted")}
//                                 onChange={(e) => handleStatusChange(e.target.value, e.target.checked)}
//                             />
//                             Posted
//                         </label>

//                         <label>
//                             <input
//                                 type="checkbox"
//                                 value="reversed"
//                                 checked={filters.status.includes("reversed")}
//                                 onChange={(e) => handleStatusChange(e.target.value, e.target.checked)}
//                             />
//                             Reversed
//                         </label>

//                         <label>
//                             <input
//                                 type="checkbox"
//                                 value="voided"
//                                 checked={filters.status.includes("voided")}
//                                 onChange={(e) => handleStatusChange(e.target.value, e.target.checked)}
//                             />
//                             Voided
//                         </label>
//                     </div>
//                 </div>

//                 <input
//                     name="minAmount"
//                     placeholder="Min Amount"
//                     value={filters.minAmount}
//                     onChange={handleChange}
//                 />
//                 <input
//                     name="maxAmount"
//                     placeholder="Max Amount"
//                     value={filters.maxAmount}
//                     onChange={handleChange}
//                 />
//                 <input
//                     name="startDate"
//                     type="date"
//                     value={filters.startDate}
//                     onChange={handleChange}
//                 />
//                 <input
//                     name="endDate"
//                     type="date"
//                     value={filters.endDate}
//                     onChange={handleChange}
//                 />

//                 <button onClick={applyFilters}>Search</button>
//             </div>

//             {/* Limit Selector */}
//             <div className="budget-line-transactions-limit-selector">
//                 <label>
//                     Show per page:
//                     <select value={pagination.limit} onChange={handleLimitChange}>
//                         <option value={10}>10</option>
//                         <option value={50}>50</option>
//                         <option value={100}>100</option>
//                     </select>
//                 </label>
//             </div>

//             {/* Table */}
//             <div className="budget-line-transactions-table-wrapper">
//                 {loading ? (
//                     <Spinner loadingInfo="Loading Transactions..." />
//                 ) : error ? (
//                     <p className="budget-line-transactions-error">{error}</p>
//                 ) : transactions.length === 0 ? (
//                     <p>No transactions found.</p>
//                 ) : (
//                     <table className="budget-line-transactions-table">
//                         <thead>
//                             <tr>
//                                 <th>Reference</th>
//                                 <th>Budget Line</th>
//                                 <th>Type</th>
//                                 <th>Status</th>
//                                 <th>Date</th>
//                                 <th>Amount</th>
//                                 <th>Remaining</th>
//                                 <th>Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {transactions.map(tx => (
//                                 <tr key={tx._id}>
//                                     <td>{tx.referenceNumber}</td>
//                                     <td>{tx.budgetLine?.programmeId?.description || '-'}</td>
//                                     <td>{tx.type}</td>
//                                     <td>{tx.status}</td>
//                                     <td>{new Date(tx.date).toLocaleDateString()}</td>
//                                     <td>{tx.amount?.toLocaleString()}</td>
//                                     <td>{tx.budgetLine ? (tx.budgetLine.amount - tx.budgetLine.spentAmount).toLocaleString() : '-'}</td>
//                                     <td className="budget-line-transactions-actions">
//                                         <Link to="/transactions/detail" state={{ transaction: tx }}><FiEye /></Link>
//                                         {/* <button onClick={() => handleDeleteClick(tx._id)} className="budget-line-delete-btn"><FiTrash2 /></button> */}
//                                     </td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 )}
//             </div>

//             {/* Pagination */}
//             {transactions.length > 0 && (
//                 <div className="budget-line-transactions-pagination">
//                     <button onClick={prevPage} disabled={pagination.page === 1}>Prev</button>
//                     <span>Page {pagination.page} of {pagination.totalPages}</span>
//                     <button onClick={nextPage} disabled={pagination.page === pagination.totalPages}>Next</button>
//                 </div>
//             )}

//             {/* Confirm Delete */}
//             {/* <ConfirmDialog
//                 show={confirmOpen}
//                 token={confirmToken}
//                 action="You are about to delete this transaction"
//                 onConfirm={handleConfirmDelete}
//                 onCancel={handleCancelDelete}
//             /> */}
//         </div>
//     );
// };

// export default BudgetLineTransactions;

import React, { useEffect, useState } from 'react';
import './BudgetLineTransactions.css';
import privateApi from '../../apis/privateApi';
// import Spinner from '../../components/Spinner/Spinner';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FiEye, FiChevronLeft, FiChevronRight } from "react-icons/fi";

const BudgetLineTransactions = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const budgetLine = location?.state?.budgetLine;

    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const [filters, setFilters] = useState({
        budgetLineId: budgetLine._id,
        referenceNumber: '', type: '', status: [],
        minAmount: '', maxAmount: '', startDate: '', endDate: '',
    });

    const [pagination, setPagination] = useState({ page: 1, limit: 10, totalPages: 1, totalRecords: 0 });

    const handleStatusChange = (value, checked) => {
        setFilters(prev => {
            let s = [...prev.status];
            if (checked) { if (!s.includes(value)) s.push(value); }
            else s = s.filter(x => x !== value);
            return { ...prev, status: s };
        });
    };

    const fetchTransactions = async (overridePage) => {
        try {
            setLoading(true); setError('');
            const params = new URLSearchParams();
            params.append('page', overridePage ?? pagination.page);
            params.append('limit', pagination.limit);
            Object.entries(filters).forEach(([k, v]) => {
                if (v != null && v !== '') {
                    if (Array.isArray(v)) v.forEach(x => params.append(k, x));
                    else params.append(k, v);
                }
            });
            const { data } = await privateApi.get(`/api/transactions?${params.toString()}`);
            if (data.success) {
                setTransactions(data.data);
                setPagination(p => ({ ...p, totalPages: data.pagination?.pages || 1, totalRecords: data.pagination?.total || data.data.length }));
            } else { setTransactions([]); setError('No records found'); }
        } catch (err) {
            setTransactions([]); setError(err.response?.data?.message || 'Failed to fetch transactions.');
        } finally { setLoading(false); }
    };

    useEffect(() => {
        const initialFetchTransactions = async (overridePage) => {
            try {
                setLoading(true); setError('');
                const params = new URLSearchParams();
                params.append('page', overridePage ?? pagination.page);
                params.append('limit', pagination.limit);
                Object.entries(filters).forEach(([k, v]) => {
                    if (v != null && v !== '') {
                        if (Array.isArray(v)) v.forEach(x => params.append(k, x));
                        else params.append(k, v);
                    }
                });
                const { data } = await privateApi.get(`/api/transactions?${params.toString()}`);
                if (data.success) {
                    setTransactions(data.data);
                    setPagination(p => ({ ...p, totalPages: data.pagination?.pages || 1, totalRecords: data.pagination?.total || data.data.length }));
                } else { setTransactions([]); setError('No records found'); }
            } catch (err) {
                setTransactions([]); setError(err.response?.data?.message || 'Failed to fetch transactions.');
            } finally { setLoading(false); }
        };

        initialFetchTransactions();

    }, [filters, pagination.page, pagination.limit]);

    const applyFilters = () => { setPagination(p => ({ ...p, page: 1 })); fetchTransactions(1); };

    const locationName = budgetLine?.stateId?.name || budgetLine?.lgaId?.name || 'Budget Line';

    return (
        <div className="bgt-page">
            {/* Header */}
            <div className="blt-header">
                <div>
                    <h1>Transactions</h1>
                    <p>{locationName} · {budgetLine?.programmeId?.code || 'Budget Line'}</p>
                </div>
                <button className="bgt-btn bgt-btn-secondary" onClick={() => navigate(-1)}>
                    <FiChevronLeft size={14} /> Back
                </button>
            </div>

            {/* Filter bar */}
            <div className="blt-filter-card">
                <span className="blt-filter-tag">Filter</span>
                <input className="blt-input" name="referenceNumber" placeholder="Reference No."
                    value={filters.referenceNumber} onChange={e => setFilters(p => ({ ...p, referenceNumber: e.target.value }))} />

                <select className="blt-select" name="type" value={filters.type}
                    onChange={e => setFilters(p => ({ ...p, type: e.target.value }))}>
                    <option value="">All Types</option>
                    <option value="debit">Debit</option>
                    <option value="credit">Credit</option>
                </select>

                <div className="blt-status-group">
                    <span className="blt-status-label">Status</span>
                    {["posted", "reversed", "voided"].map(s => (
                        <label key={s} className="blt-status-item">
                            <input type="checkbox" value={s}
                                checked={filters.status.includes(s)}
                                onChange={e => handleStatusChange(e.target.value, e.target.checked)} />
                            {s.charAt(0).toUpperCase() + s.slice(1)}
                        </label>
                    ))}
                </div>

                <input className="blt-input" name="minAmount" placeholder="Min Amount"
                    value={filters.minAmount} onChange={e => setFilters(p => ({ ...p, minAmount: e.target.value }))} />
                <input className="blt-input" name="maxAmount" placeholder="Max Amount"
                    value={filters.maxAmount} onChange={e => setFilters(p => ({ ...p, maxAmount: e.target.value }))} />
                <input className="blt-input" type="date" name="startDate"
                    value={filters.startDate} onChange={e => setFilters(p => ({ ...p, startDate: e.target.value }))} />
                <input className="blt-input" type="date" name="endDate"
                    value={filters.endDate} onChange={e => setFilters(p => ({ ...p, endDate: e.target.value }))} />

                <button className="bgt-btn bgt-btn-primary" onClick={applyFilters}>Search</button>
                <div className="blt-divider" /><div className="blt-spacer" />
                <div className="blt-per-page-wrap">
                    <span className="blt-per-page-label">Rows</span>
                    <select className="blt-select" style={{ minWidth: 70 }} value={pagination.limit}
                        onChange={e => setPagination(p => ({ ...p, limit: parseInt(e.target.value, 10), page: 1 }))}>
                        <option value={10}>10</option><option value={50}>50</option><option value={100}>100</option>
                    </select>
                </div>
            </div>

            {/* Table */}
            <div className="blt-table-card">
                {loading ? (
                    <div className="bgt-loading-wrap"><div className="bgt-spinner" /><p className="bgt-loading-text">Loading Transactions…</p></div>
                ) : error ? (
                    <div className="blt-error">⚠ {error}</div>
                ) : transactions.length === 0 ? (
                    <div className="blt-empty"><span className="blt-empty-icon">🧾</span>No transactions found.</div>
                ) : (
                    <div className="blt-table-scroll">
                        <table className="blt-table">
                            <thead>
                                <tr>
                                    <th>Reference</th><th>Budget Line</th><th>Type</th>
                                    <th>Status</th><th>Date</th><th>Amount (₦)</th><th>Remaining (₦)</th><th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {transactions.map(tx => (
                                    <tr key={tx._id}>
                                        <td className="ref">{tx.referenceNumber}</td>
                                        <td>{tx.budgetLine?.programmeId?.description || '—'}</td>
                                        <td><span className={`blt-type ${tx.type}`}>{tx.type}</span></td>
                                        <td><span className={`blt-status-badge ${tx.status}`}>{tx.status}</span></td>
                                        <td>{new Date(tx.date).toLocaleDateString()}</td>
                                        <td className="amount">{tx.amount?.toLocaleString()}</td>
                                        <td className="remaining">
                                            {tx.budgetLine
                                                ? (tx.budgetLine.amount - tx.budgetLine.spentAmount).toLocaleString()
                                                : '—'}
                                        </td>
                                        <td>
                                            <div className="blt-action">
                                                <Link className="blt-icon-btn" to="/transactions/detail" state={{ transaction: tx }}>
                                                    <FiEye size={14} />
                                                </Link>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Pagination */}
            {transactions.length > 0 && (
                <div className="blt-pagination">
                    <button className="blt-page-btn" onClick={() => setPagination(p => ({ ...p, page: p.page - 1 }))} disabled={pagination.page === 1}>
                        <FiChevronLeft size={13} /> Prev
                    </button>
                    <span className="blt-page-info">Page {pagination.page} of {pagination.totalPages} <span style={{ opacity: .6 }}>({pagination.totalRecords} total)</span></span>
                    <button className="blt-page-btn" onClick={() => setPagination(p => ({ ...p, page: p.page + 1 }))} disabled={pagination.page === pagination.totalPages}>
                        Next <FiChevronRight size={13} />
                    </button>
                </div>
            )}
        </div>
    );
};

export default BudgetLineTransactions;